<template>
  <Popup v-bind="$attrs" v-on="$listeners">
    <div class="authenPopupBox">
      <div class="authenPopupTip">您有待完成的认证信息，快去认证吧！</div>
      <div class="authenPopupText">为了便于您快速完成进件申请，请先完成实名认证后再继续申请。</div>
    </div>
  </Popup>
</template>
<script>
import Popup from './Popup.vue';

export default {
  name: 'authenPopup',
  data() {
    return {};
  },
  components: {
    Popup,
  },
  methods: {
    clickImgCode() {
      this.$emit('sendPicCode');
    },
  },
};
</script>
<style scoped>
.authenPopupBox {
  text-align: left;
}
.authenPopupTip {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #001f33;
  margin-bottom: 12px;
}
.authenPopupText {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #495060;
  letter-spacing: 0;
}
</style>
